import axios from 'axios'
import { useAuthHeader, useAuthUser } from 'react-auth-kit'
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
// import AddButton from '../../usables/small/AddButton'
import Table from '../../usables/Table'
import Modal from '../../usables/Modal'
import Input from '../../usables/small/Input'
import Spinner from '../../usables/small/Spinner'
import ClosingAlert from '../../usables/Alert'


export default function  Subjects() {
  const auth  = useAuthHeader()
  const authUser  = useAuthUser()
  const [formData, setFormData] = useState({subject_name: ''})
  const [subjects, setSubjects] = useState([])
  const [dataLoaded, setDataLoaded] = useState({done: false, sucssess: false, items: 0})
  const [errorMsg, setErrorMsg] = useState('Nepavyko įrašyti reikšmės')
  const [showError, setShowError] = useState(false)

  const tableColumns = [{
    Header: "Mokytojai",
    columns: [
      {
        Header: "Dalykas",
        accessor: "subject_name"
      },
      {
        Header: "Veiksmai",
        accessor: "action"
      }
    ]
  }]

  const config = {
    headers: {
      Authorization: auth()
    }
  }

  const createSubject = () => {
    axios.post(process.env.REACT_APP_API + '/subject', formData, config)
      .then((res)=>{
        if(res.status === 200){
          res.data.subject.action = <Link className='text-violet-500 hover:text-violet-700' to={'/dashboard/subjects/' + res.data.subject.id}>Daugiau</Link>
          setSubjects(users => [res.data.subject, ...users ])
        }
      })
      .catch((err) => {
        setErrorMsg(err.response.data.message)
        setShowError(true)
      })
    }

  useEffect(() => {
    axios.get(process.env.REACT_APP_API + '/subject', config)
    .then(res => {
      if(res.status === 200){
        //console.log(...res.data)
        setSubjects([]) //! Pašalinti prieš buildinant
        res.data.forEach((data) => {
          data.action = <Link className='text-violet-500 hover:text-violet-700' to={'/dashboard/subjects/' + data.id}>Daugiau</Link>
          setSubjects(subjects => [...subjects, data])
          
        })
        setDataLoaded({done: true, sucssess: true, items: res.data.length})
      }
    })
    .catch(err => {
      setSubjects([]) //! Pašalinti prieš buildinant
      //console.log(err.response.data)
      setSubjects(subjects => [...subjects, err.response.data])
      setDataLoaded({done: true, sucssess: false, items: 0})
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  return (
    <>
      <h2>Mokomieji dalykai</h2>
      <ClosingAlert type='error' message={errorMsg} show={showError} updateState={(value) => {setShowError(value)}} />
      {!dataLoaded.done
      ? <Spinner />
      : dataLoaded.sucssess
        ?dataLoaded.items
          ? <Table columns={tableColumns} data={subjects} />
          : <ClosingAlert type='warning' message='Nerasta mokomūjų dalykų' />
        : <ClosingAlert type='error' message='Kažkas nepavyko, bendykite vėl šiek tiek vėliau' />
      }
    {/* <Table columns={tableColumns} data={subjects} />
    <ul>
    Mokomieji dalykai: 
    {subjects.map(subject => {
      return <li key={subject.id}>{JSON.stringify(subject)} <Link to={'/dashboard/subjects/' + subject.id}>Daugiau</Link></li>
    })}
    </ul> */}
    {/* <AddButton /> */}
    {authUser().roles.admin &&
    <Modal showAddBtn={true} title='Naujas dalykas' saveText='Sukurti' submitFunction={() => createSubject()}>
      <div className='pt-5'>
        <Input
          label='Pavadinimas'
          name='subject_name'
          type='text'
          value={formData.subject_name}
          onChange={(e)=>setFormData({...formData, subject_name: e.target.value})}
          />
        </div>
      </Modal>
}
    </>
  )
}